export enum WebSocketEvent {
  DEVICES_SUBSCRIBE = 'devicesSubscribe',
  DEVICES_CHANGED = 'devicesChanged',

  EXCEPTION = 'exception'
}
